import {NavigationContainer} from '@react-navigation/native';
import {
  createNativeStackNavigator,
  NativeStackNavigationProp,
} from '@react-navigation/native-stack';
import Login from '../pages/Auth/Login/Login';
import RecoverPassword from '../pages/Auth/RecoverPassword/RecoverPassword';
import ResetTokenScreen from '../pages/Auth/RecoverPassword/ResetTokenScreen';
import NewPasswordScreen from '../pages/Auth/RecoverPassword/NewPasswordScreen';
import RecoverySent from '../pages/Auth/RecoverySent/RecoverySent';
import RegisterCode from '../pages/Auth/Register/RegisterCode/RegisterCode';
import RegisterForm from '../pages/Auth/Register/RegisterForm/RegisterForm';
import ResendToken from '../pages/Auth/ResendToken/ResendToken';
import TokenScreen from '../pages/Auth/TokenScreen/TokenScreen';
import ValidatedToken from '../pages/Auth/ValidatedToken/ValidatedToken';
import {useAuthStore} from '../store/AuthStore';
import Home from '../pages/Home/Home';
import ProductDetails from '../pages/ProductDetails/ProductDetails';
import {MainTabScreen} from './TabNavigation/HomeTabScreen';
import Bag from '../pages/Bag/Bag';
import Debts from '../pages/Debts/Debts';
import Profile from '../pages/Profile/Profile';
import Equipament from '../pages/Equipment/Equipament';
import Exchanges from '../pages/Exchanges/Exchanges';
import Support from '../pages/Support/Support';
import RequestEquipament from '../pages/RequestEquipament/RequestEquipament';
import Orders from '../pages/Orders/Orders';
import OrderSent from '../pages/OrderSent/OrderSent';
import OrderSentPix from '../pages/OrderSentPix/OrderSentPix';
import CampaignsDetails from '../pages/CampaignsDetails/CampaignsDetails';
import OrderEquipaments from '../pages/OrderEquipaments/OrderEquipaments';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import {RootStackParamList} from './Routes.types';
import FavoriteProducts from '../pages/FavoriteProducts/FavoriteProducts';
import RequestCompany from '../pages/RequestCompany/RequestCompany';
import NPS from '../pages/NPS/NPS';
import Checkout from '../pages/Checkout/Checkout';
import Containers from '../pages/Containers/Containers';
import ContainersRequest from '../pages/ContainersRequest/ContainersRequest';
import RequestEquipmentList from '../pages/RequestEquipmentList/RequestEquipmentList';
import OrderDetails from '../pages/OrderDetails/OrderDetails';
import CancelOrder from '../pages/CancelOrder/CancelOrder';
import ExchangeProduct from '../pages/ExchangeProduct/ExchangeProduct';
import NFSig from '../pages/NFSig/NFSig';
import Notifications from '../pages/Notifications/Notifications';
import SuggestedCombo from '../pages/SuggestedCombo/SuggestedCombo';
import DebtsPayment from '../pages/DebtsPayment/DebtsPayment';
import DebtsPaymentPix from '../pages/DebtsPaymentPix/DebtsPaymentPix';
import MyCards from '../pages/MyCards/MyCards';
import NewCard from '../pages/NewCard/NewCard';

import { getAnalytics, logScreenView } from '@react-native-firebase/analytics';
import React from 'react';
import OffersScreen from '../pages/OffersScreen/OffersScreen';
import CatalogBrowseScreen from '../pages/CatalogBrowseScreen/CatalogBrowseScreen';
import ScheduledOrderMenu from '../pages/ScheduledOrderMenu/ScheduledOrderMenu';
import AVistaOrderReview from '../pages/AVistaOrderReview/AVistaOrderReview';
import ScheduledOrderReview from '../pages/ScheduledOrderReview/ScheduledOrderReview';
import EquipmentMaintenance from '../pages/Equipment/EquipmentMaintenance';
import EquipmentMaintenanceList from '../pages/Equipment/EquipmentMaintenanceList';
const HomeStack = createNativeStackNavigator<RootStackParamList>();
const PublicStack = createNativeStackNavigator<RootStackParamList>();
export type NavigationProps = NativeStackNavigationProp<RootStackParamList>;

export const HomeStackScreen = () => {
  return (
    <HomeStack.Navigator >
      <HomeStack.Screen
        options={{
          headerShown: false,
        }}
        name="Home"
        component={Home}
      />
    </HomeStack.Navigator>
  );
};

export const PrivateStackScreen = () => {
  return (
    <HomeStack.Navigator >
      <HomeStack.Screen
        options={{
          headerShown: false,
        }}
        name="MainTabScreen"
        component={MainTabScreen}
      />
      <HomeStack.Screen
        options={{
          headerShown: false,
        }}
        name="ProductDetails"
        component={ProductDetails}
      />
      <HomeStack.Screen
        options={{
          headerShown: false,
        }}
        name="Bag"
        component={Bag}
      />
      <HomeStack.Screen
        options={{
          headerShown: false,
        }}
        name="Debts"
        component={Debts}
      />
      <HomeStack.Screen
        options={{
          headerShown: false,
        }}
        name="Profile"
        component={Profile}
      />
      <HomeStack.Screen
        options={{
          headerShown: false,
        }}
        name="Equipamentos"
        component={Equipament}
      />
      <HomeStack.Screen
        options={{
          headerShown: false,
        }}
        name="EquipmentMaintenanceList"
        component={EquipmentMaintenanceList}
      />
      <HomeStack.Screen
        options={{
          headerShown: false,
        }}
        name="EquipmentMaintenance"
        component={EquipmentMaintenance}
      />
      <HomeStack.Screen
        options={{
          headerShown: false,
        }}
        name="Trocas"
        component={Exchanges}
      />
      <HomeStack.Screen
        options={{
          headerShown: false,
        }}
        name="Support"
        component={Support}
      />
      <HomeStack.Screen
        options={{
          headerShown: false,
        }}
        name="RequestEquipament"
        component={RequestEquipament}
      />
      <HomeStack.Screen
        options={{
          headerShown: false,
        }}
        name="Meus pedidos"
        component={Orders}
      />
      <HomeStack.Screen
        options={{
          headerShown: false,
        }}
        name="OrderSent"
        component={OrderSent}
      />
      <HomeStack.Screen
        options={{
          headerShown: false,
        }}
        name="OrderSentPix"
        component={OrderSentPix}
      />
      <HomeStack.Screen
        options={{
          headerShown: false,
        }}
        name="CampaignsDetails"
        component={CampaignsDetails}
      />
      <HomeStack.Screen
        options={{
          headerShown: false,
        }}
        name="OrderEquipaments"
        component={OrderEquipaments}
      />
      <HomeStack.Screen
        options={{
          headerShown: false,
        }}
        name="RequestEquipmentList"
        component={RequestEquipmentList}
      />
      <HomeStack.Screen
        options={{
          headerShown: false,
        }}
        name="RequestCompany"
        component={RequestCompany}
      />
      <HomeStack.Screen
        options={{
          headerShown: false,
        }}
        name="FavoriteProducts"
        component={FavoriteProducts}
      />
      <HomeStack.Screen
        options={{
          headerShown: false,
        }}
        name="NPS"
        component={NPS}
      />
      <HomeStack.Screen

        options={{
          headerShown: false,
        }}
        name="SuggestedCombo"
        component={SuggestedCombo}
      />
      <HomeStack.Screen
        options={{
          headerShown: false,
        }}
        name="Checkout"
        component={Checkout}
      />
      <HomeStack.Screen
        options={{
          headerShown: false,
        }}
        name="Containers"
        component={Containers}
      />
      <HomeStack.Screen
        options={{
          headerShown: false,
        }}
        name="ContainersRequest"
        component={ContainersRequest}
      />
      <HomeStack.Screen
        options={{
          headerShown: false,
        }}
        name="Notifications"
        component={Notifications}
      />
      <HomeStack.Screen
        options={{
          headerShown: false,
        }}
        name="Detalhes do Pedido"
        component={OrderDetails}
      />
      <HomeStack.Screen
        options={{
          headerShown: false,
        }}
        name="Cancelar Pedido"
        component={CancelOrder}
      />
      <HomeStack.Screen
        options={{
          headerShown: false,
        }}
        name="Trocar Produto"
        component={ExchangeProduct}
      />
      <HomeStack.Screen
        options={{
          headerShown: false,
        }}
        name="DebtsPayment"
        component={DebtsPayment}
      />
      <HomeStack.Screen
        options={{
          headerShown: false,
        }}
        name="DebtsPaymentPix"
        component={DebtsPaymentPix}
      />
      <HomeStack.Screen
        options={{
          headerShown: false,
        }}
        name="MyCards"
        component={MyCards}
      />
      <HomeStack.Screen
        options={{
          headerShown: false,
        }}
        name="NewCard"
        component={NewCard}
      />
      <HomeStack.Screen
        options={{
          headerShown: false,
        }}
        name="OffersScreen"
        component={OffersScreen}
      />
      <HomeStack.Screen
        options={{
          headerShown: false,
        }}
        name="CatalogBrowseScreen"
        component={CatalogBrowseScreen}
      />
      <HomeStack.Screen
        options={{
          headerShown: false,
        }}
        name="ScheduledOrderMenu"
        component={ScheduledOrderMenu}
      />
      <HomeStack.Screen
        options={{
          headerShown: false,
        }}
        name="ScheduledOrderReview"
        component={ScheduledOrderReview}
      />
      {/* PAG-01 — o pedido a pagar. Tela irmã da revisão programada, alcançada
          pelo mesmo menu, sem ato de aceite. */}
      <HomeStack.Screen
        options={{
          headerShown: false,
        }}
        name="AVistaOrderReview"
        component={AVistaOrderReview}
      />
    </HomeStack.Navigator>
  );
};

export const PublicStackScreen = () => {
  return (
    <PublicStack.Navigator initialRouteName="Login">
      <PublicStack.Screen
        options={{
          headerShown: false,
        }}
        name="Login"
        component={Login}
      />
      <PublicStack.Screen
        options={{
          headerShown: false,
        }}
        name="RegisterCode"
        component={RegisterCode}
      />
      <PublicStack.Screen
        options={{
          headerShown: false,
        }}
        name="RegisterForm"
        component={RegisterForm}
      />
      <PublicStack.Screen
        options={{
          headerShown: false,
        }}
        name="TokenScreen"
        component={TokenScreen}
      />
      <PublicStack.Screen
        options={{
          headerShown: false,
        }}
        name="ValidatedToken"
        component={ValidatedToken}
      />
      <PublicStack.Screen
        options={{
          headerShown: false,
        }}
        name="ResendToken"
        component={ResendToken}
      />
      <PublicStack.Screen
        options={{
          headerShown: false,
        }}
        name="RecoverPassword"
        component={RecoverPassword}
      />
      <PublicStack.Screen
        options={{
          headerShown: false,
        }}
        name="ResetToken"
        component={ResetTokenScreen}
      />
      <PublicStack.Screen
        options={{
          headerShown: false,
        }}
        name="NewPassword"
        component={NewPasswordScreen}
      />
      <PublicStack.Screen
        options={{
          headerShown: false,
        }}
        name="RecoverySent"
        component={RecoverySent}
      />
      <HomeStack.Screen
        options={{
          headerShown: false,
        }}
        name="NFSig"
        component={NFSig}
        options={{ title: 'NFSig', headerShown: true }}
      />
    </PublicStack.Navigator>
  );
};

const Routes = () => {
  const token = useAuthStore(state => state.token);
  const routeNameRef = React.useRef();
  const navigationRef = React.useRef();
  const analyticsInstance = getAnalytics();

  return (
    <NavigationContainer 
    ref={navigationRef}
    onReady={() => {
      routeNameRef.current = navigationRef.current.getCurrentRoute().name;
    }}
    onStateChange={async () => {
      const previousRouteName = routeNameRef.current;
      const currentRouteName = navigationRef.current.getCurrentRoute().name;

      if (previousRouteName !== currentRouteName) {
        await logScreenView(analyticsInstance, {
          screen_name: currentRouteName,
          screen_class: currentRouteName,
        });
      }
      routeNameRef.current = currentRouteName;
    }}>
      {token ? <PrivateStackScreen /> : <PublicStackScreen />}
    </NavigationContainer>
  );
};

export default Routes;
